<template lang="pug">
div.ciclicCellphone
  div.ciclicCellphone__container
    div.ciclicCellphone__image
      img(alt="Proteja seu celular com o Seguro Celular" src="@/assets/icons/protected-cellphone.svg")
    div.ciclicCellphone__text
      small.ciclicCellphone__text__small Seguro Celular
      p.ciclicCellphone__text__title Que tal proteger seu celular contra furto e quebra em sua viagem?
    div.ciclicCellphone__cta
      a.ciclicCellphone__cta__link(href="/seguro-celular/#/?utm_source=site_ciclic&utm_medium=conversao_viagem&utm_campaign=cross_celular_pagamento_2022", target="_blank") Cotar agora
</template>

<script>
export default {
  name: 'CellphoneCTA'
}
</script>

<style lang="scss" scoped>
@import "~@/style/ui/variables";
@import "~@/style/ui/sizes";

$hightlight-color: #72F951;
$darken-color: #323232;

.ciclicCellphone {
  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 31.5px;
    border-radius: 12px;
    background-color: $darken-color;
    color: white;

    @media #{$mobile-query} {
      flex-direction: column;
      padding: 24px;
    }
  }

  &__image {
    background-color: $hightlight-color;
    border-radius: 50%;
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__text {
    text-align: left;
    max-width: calc(100% - 234px);
    margin-left: 24px;
    margin-right: auto;
    line-height: 0;
    font-family: $oscine-font-family;

    @media #{$mobile-query} {
      max-width: 100%;
      text-align: center;
      margin: 16px 0;
    }

    &__small {
      color: $hightlight-color;
      font-size: 12px;
      line-height: 14px;
    }

    &__title {
      font-size: 18px;
      line-height: 23px;
      font-weight: 700;
    }
  }

  &__cta {
    &__link {
      background-color: $hightlight-color;
      font-size: 14px;
      padding: 12px 24px;
      border-radius: 28px;
      color: $darken-color;
      white-space: nowrap;
      transition: 250ms ease-in-out all;
      display: inline-block;

      &:hover {
        background-color: darken($hightlight-color, 7%);
      }
    }
  }
}
</style>
